import { render, staticRenderFns } from "./newPlatformBtn.vue?vue&type=template&id=d16cd11c&scoped=true&"
import script from "./newPlatformBtn.vue?vue&type=script&lang=js&"
export * from "./newPlatformBtn.vue?vue&type=script&lang=js&"
import style0 from "./newPlatformBtn.vue?vue&type=style&index=0&id=d16cd11c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16cd11c",
  null
  
)

export default component.exports